import * as React from 'react'
import { Router } from 'routes'
import { useTranslation } from 'i18n'
import { ActionSheet } from 'components'

const Component = ({ open, onClose }) => {
  const { t } = useTranslation('common')

  const onRouteNewItem = index => {
    const routes = ['video', 'audio', 'magazine']
    Router.pushRoute('newItem', { type: routes[index] })
  }

  return (
    <ActionSheet
      options={[t('video'), t('audio'), t('magazine')]}
      open={open}
      onClose={onClose}
      cancel={true}
      onClick={onRouteNewItem}
    />
  )
}

export default Component
